module.exports = __webpack_public_path__ + "static/img/case-dy-page-bg-06.0eee62b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dy/case-dy-page-bg-06.jpg
// module id = g2KX
// module chunks = 1